<template>
  <ListTemplate
    :fields="fields"
    :api-url="apiURL"
    title="Project Permissions"
  />
</template>

<script>
/**
 * View to list all Project Permissions for a Group
 */
import ListTemplate from '@/components/ListTemplate'
import groupAPI from '@/api/group'

export default {
  components: {
    ListTemplate,
  },
  props: {
    groupId: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      fields: [
        {
          name: 'id',
          visible: false,
        },
        {
          name: 'usr_role',
          title: 'User Role',
          formatter: this.getName,
        },
        {
          name: 'project_state',
          title: 'Project State',
          formatter: this.getName,
        },
        {
          name: 'method',
          title: 'Method',
          filterType: String,
        },
        {
          name: 'resource',
          title: 'Resource',
          filterType: String,
        },
        {
          name: 'actions',
          title: 'Actions',
          titleClass: 'center aligned',
          dataClass: 'center aligned',
        },
      ],
    }
  },
  computed: {
    apiURL () {
      return groupAPI.projectPermissionsURL(this.groupId)
    },
  },
  methods: {
    getName (obj) {
      if (obj) {
        return obj.name
      }
      return '*'
    },
  },
}
</script>
